import {endpoints} from './endpoints'
import request from '../request'

export function createCostCategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostCategory,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostSubcategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostSubcategory,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostItem (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostItem,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyCostItems (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyCostItems,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCostCategories (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCostCategories,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCostCategory (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCostCategory,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function saveAllCostCategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.saveAllCostCategory,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostCategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostCategory,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostSubcategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostSubcategory,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostItem (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostItem,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}


// Config

export function getCostCategoriesCompany (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCostCategoriesCompany,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyBaseProjectCostCategories (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyBaseProjectCostCategories,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function saveAllCostCategoriesCompanyConfig (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.saveAllCostCategoriesCompanyConfig,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCostBaseProjects (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCostBaseProjects,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostBaseProject (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostBaseProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCostBaseProject (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCostBaseProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostBaseProject (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostBaseProject,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostSpecialtyCompany (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostSpecialtyCompany,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCostSpecialtiesCompany (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCostSpecialtiesCompany,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCostSpecialty (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCostSpecialty,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostSpecialtyCompany (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostSpecialtyCompany,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostSubCategoryCompany (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostSubCategoryCompany,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCostSubCategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCostSubCategory,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostSubCategoryCompany (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostSubCategoryCompany,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostItemCompany (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostItemCompany,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCostItem (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCostItem,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostItemCompany (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostItemCompany,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostCenter (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostCenter,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCostCenter (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCostCenter,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostCenter (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostCenter,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCostTemplate (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCostTemplate,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyCostTemplates (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyCostTemplates,
			method: 'get',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCostTemplate (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCostTemplate,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

//Nuevo Sistema

export function updateProjectCostInfo (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateProjectCostInfo,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjectCostDetail (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectCostDetail,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function saveSupervisionItem (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.saveSupervisionItem,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateSupervisionPaymentObservation (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateSupervisionPaymentObservation,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function saveProjectCostDetail (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.saveProjectCostDetail,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function sendTableCostTotalsToClient (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.sendTableCostTotalsToClient,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function sendSupervisionTableToClient (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.sendSupervisionTableToClient,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function generateTableCostTotalsPdf (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.generateTableCostTotalsPdf,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function generateSupervisionTablePdf (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.generateSupervisionTablePdf,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

// Config

export function setCompanyCostCategory (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setCompanyCostCategory,
			method: 'post',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCompanyCostCategory (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCompanyCostCategory,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyCostCategories (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyCostCategories,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyCostCategory (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyCostCategory,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyMaterials (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyMaterials,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCompanyMaterial (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCompanyMaterial,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCompanyMaterial (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCompanyMaterial,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCompanyMaterial (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCompanyMaterial,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanySupervisionPercents (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanySupervisionPercents,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createCompanySupervisionPercent (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCompanySupervisionPercent,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateCompanySupervisionPercent (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateCompanySupervisionPercent,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function deleteCompanySupervisionPercent (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.deleteCompanySupervisionPercent,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setProjectSelectionToSubcontractor (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setProjectSelectionToSubcontractor,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjectSelectionToSubcontractor (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjectSelectionToSubcontractor,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}